var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.deviceCanShare)?_c('button',{staticClass:"btn_share",attrs:{"type":"button"},on:{"click":_vm.openShareSheet}},[_vm._v("\n  Share SKU\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }